import { ImagerCapability } from "../../Model/ImagerCapabilities";
import { Collection } from "../../Model/Collection";

export enum EImagerCapabilitiesAction {
  FETCH_IMAGER_CAPABILITIES_PENDING = "FETCH_IMAGER_CAPABILITIES_PENDING",
  FETCH_IMAGER_CAPABILITIES_SUCCESS = "FETCH_IMAGER_CAPABILITIES_SUCCESS",
  FETCH_IMAGER_CAPABILITIES_ERROR = "FETCH_IMAGER_CAPABILITIES_ERROR",
  UPDATE_IMAGER_CAPABILITIES = "FETCH_IMAGER_CAPABILITIES",
}

export interface ImagerCapabilitiesAction {
  type: EImagerCapabilitiesAction;
  imagerCapabilities: Collection<ImagerCapability> | null;
  error: any;
}

export function fetchImagerCapabilitiesPending(): ImagerCapabilitiesAction {
  return {
    type: EImagerCapabilitiesAction.FETCH_IMAGER_CAPABILITIES_PENDING,
    error: null,
    imagerCapabilities: null,
  };
}

export function fetchImagerCapabilitiesSuccess(
  imagerCapabilities: Collection<ImagerCapability>
): ImagerCapabilitiesAction {
  return {
    type: EImagerCapabilitiesAction.FETCH_IMAGER_CAPABILITIES_SUCCESS,
    imagerCapabilities: imagerCapabilities,
    error: null,
  };
}

export function fetchImagerCapabilitiesError(error: any): ImagerCapabilitiesAction {
  return {
    type: EImagerCapabilitiesAction.FETCH_IMAGER_CAPABILITIES_ERROR,
    error: error,
    imagerCapabilities: null,
  };
}

export function updateImagerCapabilities(
  imagerCapabilities: Collection<ImagerCapability>
): ImagerCapabilitiesAction {
  return {
    type: EImagerCapabilitiesAction.UPDATE_IMAGER_CAPABILITIES,
    imagerCapabilities: imagerCapabilities,
    error: null,
  };
}
